import Hashids from 'hashids';

const salt = process.env.HASHID_SALT;
const minLength = 8;

const hashid = new Hashids(salt, minLength);

export function decodeId(hashId) {
  const [id] = hashid.decode(hashId);
  return id;
}

export function encodeId(id) {
  const encoded = hashid.encode(id);
  return encoded;
}
